export default __webpack_public_path__ + "static/media/pvsa.a8c21529.jpg";